import { all } from "redux-saga/effects";
import { chungChiChungNhanSaga } from "./chungChiChungNhanSaga";
import { ChungChiChungNhanSinhVienSaga } from "./chungChiChungNhanSinhVienSaga";

export default function* chungChiChungNhanSagaWrapper() {
    yield all([
        chungChiChungNhanSaga(),
        ChungChiChungNhanSinhVienSaga(),
    ]);
}